import { render } from "./PronosticoCompraDirecta.vue?vue&type=template&id=9f204e76&scoped=true"
import script from "./PronosticoCompraDirecta.vue?vue&type=script&lang=js"
export * from "./PronosticoCompraDirecta.vue?vue&type=script&lang=js"

import "./PronosticoCompraDirecta.vue?vue&type=style&index=0&id=9f204e76&scoped=true&lang=css"
import "./PronosticoCompraDirecta.vue?vue&type=style&index=1&id=9f204e76&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f204e76"]])

export default __exports__